var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isSidebar)?_c('main-layout',[_c('router-view'),_c('global-notifications'),_c('confirm-dialog')],1):_c('v-main',[_c('router-view'),_c('global-notifications'),_c('confirm-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }